/* eslint-disable i18next/no-literal-string -- The prerendered fallback is rendered before i18n initialization. */
import { settings } from '@rhim/design';
import { type CSSProperties } from 'react';

const backgroundStyle: CSSProperties = {
  position: 'fixed',
  height: '100vh',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: settings.colors.Primary.Grey_1,
};

const wrapperStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  display: 'grid',
  placeContent: 'center',
};

const indicatorStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  padding: settings.Spacing.Spacing_200,
  marginBottom: 0,
  color: settings.colors.Primary.Grey_8,
  backgroundColor: settings.colors.Monochromatic.White,
  border: `1px solid ${settings.colors.Primary.Grey_2}`,
  borderRadius: '28px',
  boxShadow: '0 2px 16px 0 rgba(61, 85, 103, 0.1)',
  fontFamily: settings.typography.FontFamily.Medium,
  fontSize: settings.typography.FontSize.Small,
};

const spinnerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  pointerEvents: 'none',
};

const messageStyle: CSSProperties = {
  marginLeft: settings.Spacing.Spacing_150,
  marginRight: settings.Spacing.Spacing_150,
};

/**
 * Prerender-safe equivalent of PageLoadingScreen's English window variant.
 * All required styles and animation are included in the generated markup.
 */
export function StaticPageLoadingScreen() {
  return (
    <div aria-busy="true" aria-live="polite" style={backgroundStyle}>
      <div style={wrapperStyle}>
        <div style={indicatorStyle}>
          <Spinner />
          <span style={messageStyle}>Loading…</span>
        </div>
      </div>
    </div>
  );
}

function Spinner() {
  return (
    <div aria-hidden="true" style={spinnerStyle}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
          <path
            fill="#D7DCE0"
            d="M4.625 17.255c.412-.37 1.045-.334 1.412.078C4.724 15.866 4 13.972 4 12c0-4.411 3.589-8 8-8-.552 0-1-.447-1-1 0-.553.448-1 1-1C6.486 2 2 6.486 2 12c0 2.465.904 4.833 2.547 6.667-.368-.412-.334-1.044.078-1.412"
          />
          <path
            fill={settings.colors.Operational.State_Blue_2}
            d="M12 22c-2.841 0-5.558-1.215-7.453-3.333-.368-.412-.334-1.044.078-1.412.412-.369 1.045-.334 1.412.078C7.554 19.028 9.727 20 12 20c4.411 0 8-3.589 8-8s-3.589-8-8-8c-.552 0-1-.447-1-1 0-.553.448-1 1-1 5.514 0 10 4.486 10 10s-4.486 10-10 10"
          />
          <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite" />
        </g>
      </svg>
    </div>
  );
}
